import Lottie from 'react-lottie';
import './Success_horozontal_Lottie.css';
import * as animationData from './Success_horozontal_Lottie.json';

function Success_horozontal_Lottie() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <section className='main'>
      <div className='Success_horozontal_Lottie_icon'>
        <Lottie className="me-auto"
          options={defaultOptions}
        />
      </div>
    </section>
  );
}
export default Success_horozontal_Lottie;